import * as angular from "angular";
import { CredentialsManager } from "../../shared/credentials-manager";

let env = {};

//Import variables if present (from env.js)
if (window) {
    angular.extend(env, window["__env"]);
}
let app = angular.module("signin", [
    "ngCookies",
    "credentialsManager",
    "ngSanitize",
    "ngMaterial",
    "vcServices",
    "vcDataProvider",
    "login",
    "vcHelper",
    "theme",
    "whiteLabelTheme",
]);

app.config(($httpProvider: any) => {
    $httpProvider.defaults.withCredentials = true;
});
app.config([
    "$locationProvider",
    ($locationProvider: any) => {
        $locationProvider.hashPrefix("");
    },
]);
app.config(($sceDelegateProvider: any, __env: any) => {
    $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        "self",
        // Allow loading from our assets domain.  Notice the difference between * and **.
        "https://assets." + __env.host + "/**",
    ]);
});

//This makes sure that when inputs autofill with chrome, that the labels do not stay in the input causing ugly overlap
app.directive("mdInputContainer", ($timeout: any) => {
    return ($scope: any, element: any) => {
        let ua = navigator.userAgent;
        if (ua.match(/chrome/i) && !ua.match(/edge/i)) {
            $timeout(() => {
                if (element[0].querySelector("input:-webkit-autofill")) {
                    element.addClass("md-input-has-value");
                }
            }, 200);
        }
    };
});

// Register environment in AngularJS as constant
app.constant("__env", env);
app.constant("__app_type", "USER");
app.constant("__time_zone", Intl.DateTimeFormat().resolvedOptions().timeZone);

export class SignInController {
    private readonly $scope: any;
    private readonly $http: any;
    private $window: any;
    private readonly $location: any;
    private $cookies: any;
    private readonly __env: any;
    private credentialsManager: CredentialsManager;
    private __time_zone: any;

    public forgot_password = { error: false };
    public login: any = {};
    public authenticateLogin = false;
    public view = "signin";
    public slug: any = {};
    public slug_error: string | null = "";
    public slug_loading = false;
    public viewPassword = false;
    public flow = "ecanvasser";
    public url: any;
    public signin_redirect: string;
    public message: string | undefined;
    public login_loading: boolean;
    public authenticate: object | undefined;
    public error: string | undefined;
    public errorName: string | undefined;
    public successMessage: string | undefined;
    public forgot_password_error: string | null = null;
    public forgot_password_success: string | null = null;
    public forgot_password_loading: boolean | null = null;
    public loginType: string;
    public phoneLogin: any;

    constructor(
        $scope: any,
        $http: any,
        $window: any,
        $location: any,
        $cookies: any,
        __env: any,
        CredentialsManager: CredentialsManager,
        __time_zone: any
    ) {
        this.$scope = $scope;
        this.$http = $http;
        this.$window = $window;
        this.$location = $location;
        this.$cookies = $cookies;
        this.__env = __env;
        this.credentialsManager = CredentialsManager;
        this.__time_zone = __time_zone;

        this.url = this.$location.search();

        this.signin_redirect = this.$window.location.hash.split("#/")[1];
        if (!this.signin_redirect) this.signin_redirect = "";

        if (this.$cookies.get("access_token") != undefined) {
            this.$window.location = "/#/";
        }

        if (this.signin_redirect.indexOf("voterfiles/l2") !== -1) {
            this.flow = "l2";
        }

        if (this.url.slug || this.url.slug_error) {
            this.view = "slug";
            if (this.url.slug) {
                this.slug.name = this.url.slug;
            } else {
                this.slug_error = this.url.slug_error;
                this.slug.name = this.$window.localStorage.getItem("slug");
            }
        } else {
            this.slug.name = this.$window.localStorage.getItem("slug");
        }

        if (this.url.email) {
            this.login.email = decodeURIComponent(this.url.email);
        }
        if (this.url.message) {
            this.message = this.url.message;
        }
    }

    loginSubmit(region: string): void {
        this.login_loading = true;
        this.loginType = "email";
        this.$http
            .post(
                this.getUrlBase(region) + "/login?timezone=" + encodeURIComponent(this.__time_zone),
                this.login
            )
            .then(
                (response: object) => {
                    this.handleLoginResponse(response, region);
                },
                () => {
                    this.error = "An error has occurred";
                    this.login_loading = false;
                }
            );
    }

    getUrlBase(region?: string): string {
        let url = this.__env.apiUrl();
        if (region) {
            url =
                "https://" +
                region +
                "." +
                this.__env.host +
                this.__env.apiUrl();
        }
        return url;
    }

    cancelPhoneLogin(): void {
        this.view = "signin";
    }

    handleLoginResponse(response: object, region?: string) {
        if (response["data"].success) {
            this.successRedirect(response, region);
        } else if (angular.isDefined(response["data"].region)) {
            this.loginSubmit(response["data"].region);
        } else if (response["data"].authenticate) {
            this.authenticate = {
                region: region,
                setup: false,
                key: response["data"].authKey || null,
                email: this.loginType == "email" ? this.login.email : null,
                countrycode:
                    this.loginType == "phone"
                        ? this.phoneLogin.countrycode.substring(1)
                        : null,
                phonenumber:
                    this.loginType == "phone"
                        ? this.phoneLogin.phonenumber
                        : null,
            };
            this.login_loading = false;
            this.authenticateLogin = true;
        } else if (response["data"].setupAuthNeeded) {
            this.login_loading = false;
            this.authenticate = {
                image: response["data"].imgSrc,
                secret: response["data"].secret,
                setup: true,
                region: region,
                key: response["data"].authKey || null,
                email: this.loginType == "email" ? this.login.email : null,
                countrycode:
                    this.loginType == "phone"
                        ? this.phoneLogin.countrycode.substring(1)
                        : null,
                phonenumber:
                    this.loginType == "phone"
                        ? this.phoneLogin.phonenumber
                        : null,
            };
            this.authenticateLogin = true;
        } else {
            this.error = response["data"].message;
            this.errorName = response["data"].error;
            this.login_loading = false;
        }
    }

    forgotPassword(): void {
        this.forgot_password_error = null;
        this.forgot_password_success = null;
        this.forgot_password_loading = true;
        this.$http
            .post(
                this.__env.apiUrl() + "/user/reset_password",
                this.forgot_password
            )
            .then(
                (response: object) => {
                    if (response["data"].success) {
                        this.forgot_password_success =
                            "Thank you, an email will be sent to your given address, if you have an account with us.";
                        this.view = "signin";
                    } else {
                        this.forgot_password_error = response["data"].message;
                    }
                    this.forgot_password_loading = false;
                },
                () => {
                    this.forgot_password_loading = false;
                    this.forgot_password_error = "An error has occurred";
                }
            );
    }

    successRedirect(response: object, region: string): void {
        if (this.signin_redirect && this.signin_redirect != "") {
            this.credentialsManager.redirect(
                "login",
                this.$cookies.get("campaignid"),
                region,
                this.signin_redirect
            );
        } else {
            if (response["data"].account === "ADMIN") {
                this.credentialsManager.redirect(
                    "login",
                    this.$cookies.get("campaignid"),
                    region
                );
            } else if (response["data"].account === "USER") {
                const redirect = response["data"].trialExpired ? "expired" : "";
                this.credentialsManager.redirect(
                    "login",
                    this.$cookies.get("campaignid"),
                    region,
                    redirect
                );
            } else if (response["data"].account === "LEADER") {
                this.credentialsManager.redirect(
                    "login",
                    this.$cookies.get("campaignid"),
                    region
                );
            }
        }
    }

    reset(): void {
        this.view = "signin";
        this.authenticateLogin = false;
    }

    redirectToSlug(): void {
        this.slug_error = null;
        this.slug_loading = true;
        this.$window.localStorage.setItem("slug", this.slug.name);
        this.$window.location =
            "v2/login/azure/" + this.slug.name.toLowerCase();
    }

    resendConfirmation(): void {
        this.$http
            .post(this.__env.apiUrl() + "/user/resend_confirmation", this.login)
            .then(
                (response: object) => {
                    this.successMessage = response["data"].message;
                    this.error = null;
                },
                () => {
                    this.error = "An error has occurred";
                }
            );
    }
}

app.controller("SignInController", SignInController);
